module.exports = __webpack_public_path__ + "static/media/m7.8084a0ff.png";